import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import EnergyBill from '../components/EnergyBill'

const EnergyBillPage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <EnergyBill />
            </div>
          </main>
    )
}

export default EnergyBillPage